import jsPDF from 'jspdf'

import React, { useState } from 'react';
import logo from "../Imagenes/logoSCTKD.png"
import Fondo from "../Imagenes/certificadoFondoSupercopa.jpeg"
//import QRCode from 'qrcode'
import { useEffect } from 'react';
import moment from 'moment/moment';

export function PDFCertificados(props) {

  const { asistencia } = props;
  console.log("WWWWWALUMNO", asistencia)

  let Certificados = [];

  asistencia.map((x) => {
    if (x.presente >= 1) {
      Certificados.push({
        nombre: x.nombre + " " + x.apellido,
        fecha: moment(x.fecha).format("DD/MM/YYYY"),
        dia: x.dia,
        sexo:x.sexo
      })
    }
  })


  const titulo = (valor) => {
    let sexo = "Mixto"

    switch (valor) {
      case 1:
        sexo = "Sra."
        break;
      case 2:
        sexo = "Sr."
        break;
      case 3:
        sexo = "Sr/a"
        break;

      default:
        sexo = "Sr/a"
        break;
    }
    return sexo
  }

  const mes_name = (num) => {
    let categoria = "n/c"
    switch (num) {

      case "01":
        categoria = "Enero"
        break;
      case "02":
        categoria = "Febrero"
        break;
      case "03":
        categoria = "Marzo"
        break;
      case "04":
        categoria = "Abril"
        break;
      case "05":
        categoria = "Mayo"
        break;
      case "06":
        categoria = "Junio"
        break;
      case "07":
        categoria = "Julio"
        break;
      case "08":
        categoria = "Agosto"
        break;
      case "09":
        categoria = "Septiembre"
        break;
      case "10":
        categoria = "Octubre"
        break;
      case "11":
        categoria = "Noviembre"
        break;
      case "12":
        categoria = "Diciembre"
        break;

      default:
        break;
    }

    return categoria;
  }

  let doc = new jsPDF({
    orientation: "l",
    unit: "mm",
    format: "a4",
    putOnlyUsedFonts: true,
    precision: 2,
  });

  let anio = ""

  let parte = [];
  Certificados.map((x, i) => {


    parte = x.fecha.split("/")
    let dia = parte[0]
    let mes = mes_name(parte[1]);
    anio = parte[2]
    doc.addImage(Fondo, "JPEG",0, 0, 297, 210);
    doc.setTextColor("red")
    doc.setFontSize(30);
    doc.setFont('Helvetica', 'bold')
    doc.text( `${anio}`, 144, 52)
    doc.setTextColor("black")
    doc.setFontSize(20);
    doc.setFont('Helvetica', 'bold')
    doc.text(`El ${titulo(x.sexo)} ${x.nombre}  `, 50, 75)
    doc.setFontSize(20);
    doc.text(`ha participado en la fecha Nro. ${x.dia} de la Liga `, 50, 90)
    doc.setFontSize(25);
    doc.text(` SUPER COPA TKD. `, 80, 105)
    doc.setFontSize(20);
    doc.text(`el dia ${dia} de ${mes} de ${anio}`, 120, 130)

    if (Certificados.length > i + 1) {

      doc.addPage()
    }



  })
  doc.output('save', `AsistenciaLiga${anio}.pdf`);
  // doc.save("yourDoc.pdf");


  // return (
  //   <div>
  //   </div>
  // );
}

